module.exports = __webpack_public_path__ + "static/media/IoT.e50b3073.jpg";